exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nb-validation[data-v-2509a044]{box-sizing:border-box;height:100%;position:relative;margin:0}.nb-validation-message[data-v-2509a044]{border-radius:0 3px 3px 0;border:1px solid;border-left:3px solid;padding:3px;padding-left:10px;margin:3px;position:relative}.nb-validation-message.message-error[data-v-2509a044]{color:#bc1132;border-top:1px solid #f9b3c1;border-bottom:1px solid #f9b3c1;border-left:3px solid #f43e61;border-right:1px solid #f9b3c1;background:#fff4ce}.nb-validation.title[data-v-2509a044]{display:block;font-size:14px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2509a044","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/validation.vue
// module id = 1101
// module chunks = 0